import css from '../LibraryContentMediaTable.module.scss';

export const HighlightedText = ({
  text,
  terms,
  caseSensitive = false,
}: {
  text: string;
  terms: string[];
  caseSensitive?: boolean;
}) => {
  if (terms.length === 0) return <>{text}</>;

  const escaped = terms.map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  const flags = caseSensitive ? 'g' : 'gi';
  const regex = new RegExp(`(${escaped.join('|')})`, flags);
  const parts = text.split(regex);

  return (
    <>
      {parts.map((part, i) => {
        const isMatch = caseSensitive
          ? terms.some((t) => part === t)
          : terms.some((t) => part.toLowerCase() === t.toLowerCase());
        return isMatch ? (
          <span key={i} className={css.filterHighlight}>
            {part}
          </span>
        ) : (
          <span key={i}>{part}</span>
        );
      })}
    </>
  );
};
